import { TranslationResponse } from '@/api/services/common.dto'

export interface ConfigurationFieldsTranslationsState {
    availableLanguages: Partial<TranslationResponse>[]
}
export const initialConfigurationFieldsTranslationsState =
    (): ConfigurationFieldsTranslationsState => ({
        availableLanguages: []
    })
